(function () {
  function initNcCartItems() {
    document.querySelectorAll('[data-nc-cart-items]').forEach(function (root) {
      if (root.dataset.ncCartReady === 'true') return;

      root.dataset.ncCartReady = 'true';

      function markRowAsBusy(target) {
        var row = target.closest('.line-item');
        if (!row) return;
        row.classList.add('nc-cart-items__row--busy');
      }

      root.addEventListener('click', function (event) {
        if (!(event.target instanceof Element)) return;

        var control = event.target.closest(
          '.ap-quantityselector__button, .line-item__remove-button'
        );

        if (!control) return;
        markRowAsBusy(control);
      });

      root.addEventListener('change', function (event) {
        if (!(event.target instanceof Element)) return;

        var input = event.target.closest('.ap-quantityselector__input');
        if (!input) return;

        markRowAsBusy(input);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNcCartItems);
  } else {
    initNcCartItems();
  }

  document.addEventListener('shopify:section:load', initNcCartItems);

  window.addEventListener('pageshow', function () {
    document
      .querySelectorAll('.nc-cart-items__row--busy')
      .forEach(function (row) {
        row.classList.remove('nc-cart-items__row--busy');
      });
  });
})();